// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   EndUser Portal — Employee Security Hub
   Namespace: eu- (all classes prefixed to avoid conflicts)
   Supports: light / dark / semi-dark via .dark and .semi-dark
   ============================================================ */

/* ── Custom properties ──────────────────────────────────────── */
/* Accent tokens are injected directly via inline style by EndUserPortal.js
   These :root values are last-resort fallbacks only. */
:root {
  --eu-bg:            #f5f4ff;
  --eu-surface:       #ffffff;
  --eu-surface-2:     #f8f7ff;
  --eu-border:        #e5e2f0;
  --eu-text-primary:  #1e1b4b;
  --eu-text-secondary:#6b7280;
  --eu-text-muted:    #9ca3af;
  --eu-accent:        var(--app-primary-color, #1E3A5F);
  --eu-accent-light:  rgba(30,58,95,0.12);
  --eu-accent-glow:   rgba(30,58,95,0.20);
  --eu-hero-from:     #060e1b;
  --eu-hero-to:       #0e2340;
  --eu-card-shadow:   0 2px 16px var(--eu-accent-glow);
  --eu-success:       #10b981;
  --eu-warning:       #f59e0b;
  --eu-danger:        #ef4444;
  --eu-info:          #3b82f6;
}

.dark {
  --eu-bg:            #0b0e1a;
  --eu-surface:       #111827;
  --eu-surface-2:     #1a2035;
  --eu-border:        #1f2d45;
  --eu-text-primary:  #e2e8f0;
  --eu-text-secondary:#94a3b8;
  --eu-text-muted:    #546078;
  --eu-card-shadow:   0 4px 24px rgba(0,0,0,0.5);
}

.semi-dark {
  --eu-bg:            #f5f4ff;
  --eu-surface:       #ffffff;
  --eu-surface-2:     #f8f7ff;
  --eu-border:        #e5e2f0;
  --eu-text-primary:  #1e1b4b;
  --eu-text-secondary:#6b7280;
  --eu-text-muted:    #9ca3af;
  --eu-card-shadow:   0 2px 16px var(--eu-accent-glow);
}

/* ── Layout wrapper ──────────────────────────────────────────── */
.eu-portal {
  min-height: 100vh;
  background: var(--eu-bg);
  font-family: 'Inter', system-ui, sans-serif;
  padding: 24px;
  box-sizing: border-box;
}

/* ── Hero / Welcome Banner ───────────────────────────────────── */
.eu-hero {
  position: relative;
  background: linear-gradient(135deg, var(--eu-hero-from) 0%, var(--eu-hero-to) 100%);
  border-radius: 20px;
  padding: 36px 40px;
  margin-bottom: 28px;
  overflow: hidden;
  color: #fff;
}

.eu-hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 80% 20%, rgba(255,255,255,0.07) 0%, transparent 50%),
    radial-gradient(circle at 20% 80%, rgba(255,255,255,0.05) 0%, transparent 40%);
  pointer-events: none;
}

/* Subtle dot grid */
.eu-hero::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle, rgba(255,255,255,0.08) 1px, transparent 1px);
  background-size: 28px 28px;
  pointer-events: none;
}

.eu-hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.eu-hero-left { flex: 1 1; }

.eu-greeting {
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.7);
  margin: 0 0 6px;
}

.eu-hero-name {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 10px;
  line-height: 1.15;
  color: #fff;
}

.eu-hero-sub {
  font-size: 0.875rem;
  color: rgba(255,255,255,0.75);
  margin: 0;
}

.eu-hero-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

/* Awareness Score Ring */
.eu-score-ring {
  position: relative;
  width: 96px;
  height: 96px;
  flex-shrink: 0;
}

.eu-score-ring svg {
  transform: rotate(-90deg);
}

.eu-score-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.eu-score-value {
  font-size: 1.4rem;
  font-weight: 700;
  color: #fff;
  line-height: 1;
}

.eu-score-label {
  font-size: 0.55rem;
  color: rgba(255,255,255,0.7);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-top: 2px;
}

.eu-score-info {
  text-align: left;
}

.eu-score-info-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  margin: 0 0 6px;
}

.eu-score-breakdown {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.eu-score-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  color: rgba(255,255,255,0.8);
}

.eu-score-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ── Quick Stats Row ─────────────────────────────────────────── */
.eu-stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
  margin-bottom: 28px;
}

.eu-stat-card {
  background: var(--eu-surface);
  border: 1px solid var(--eu-border);
  border-radius: 14px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: var(--eu-card-shadow);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.eu-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px var(--eu-accent-glow);
}

.eu-stat-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.eu-stat-icon svg {
  width: 22px;
  height: 22px;
}

.eu-stat-icon.purple  { background: var(--eu-accent-light); color: var(--eu-accent); }
.eu-stat-icon.red     { background: #fee2e2; color: #ef4444; }
.eu-stat-icon.blue    { background: #dbeafe; color: #3b82f6; }
.eu-stat-icon.green   { background: #d1fae5; color: #10b981; }
.eu-stat-icon.amber   { background: #fef3c7; color: #f59e0b; }

.dark .eu-stat-icon.purple  { background: var(--eu-accent-light); color: var(--eu-accent); }
.dark .eu-stat-icon.red     { background: rgba(239,68,68,0.2);   color: #f87171; }
.dark .eu-stat-icon.blue    { background: rgba(59,130,246,0.2);  color: #60a5fa; }
.dark .eu-stat-icon.green   { background: rgba(16,185,129,0.2);  color: #34d399; }
.dark .eu-stat-icon.amber   { background: rgba(245,158,11,0.2);  color: #fbbf24; }

.eu-stat-text { min-width: 0; }

.eu-stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--eu-text-primary);
  line-height: 1;
  margin-bottom: 2px;
}

.eu-stat-label {
  font-size: 0.75rem;
  color: var(--eu-text-secondary);
  font-weight: 500;
}

/* ── Main content grid ────────────────────────────────────────── */
.eu-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

@media (max-width: 900px) {
  .eu-grid { grid-template-columns: 1fr; }
}

.eu-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

@media (max-width: 1100px) {
  .eu-grid-3 { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 700px) {
  .eu-grid-3 { grid-template-columns: 1fr; }
}

/* ── Generic card ────────────────────────────────────────────── */
.eu-card {
  background: var(--eu-surface);
  border: 1px solid var(--eu-border);
  border-radius: 16px;
  padding: 22px;
  box-shadow: var(--eu-card-shadow);
}

.eu-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.eu-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--eu-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.eu-card-title-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: var(--eu-accent-light);
  color: var(--eu-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.2s, color 0.2s;
}

.eu-card-title-icon svg {
  width: 16px;
  height: 16px;
}

.eu-card-action {
  font-size: 0.75rem;
  color: var(--eu-accent);
  font-weight: 600;
  cursor: pointer;
  background: none;
  border: none;
  padding: 4px 8px;
  border-radius: 6px;
  text-decoration: none;
  transition: background 0.15s, color 0.2s;
}

.eu-card-action:hover {
  background: var(--eu-accent-light);
}

/* ── Quick Actions ───────────────────────────────────────────── */
.eu-quick-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.eu-quick-action {
  background: var(--eu-surface-2);
  border: 1px solid var(--eu-border);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-decoration: none;
}

.eu-quick-action:hover {
  border-color: var(--eu-accent);
  background: var(--eu-accent-light);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--eu-accent-glow);
}

.eu-quick-action-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.eu-quick-action-icon svg { width: 18px; height: 18px; }

.eu-quick-action-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--eu-text-primary);
  line-height: 1.3;
}

.eu-quick-action-desc {
  font-size: 0.7rem;
  color: var(--eu-text-muted);
}

/* ── Learning Progress ───────────────────────────────────────── */
.eu-course-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.eu-course-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 10px;
  background: var(--eu-surface-2);
  border: 1px solid var(--eu-border);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.eu-course-item:hover {
  border-color: var(--eu-accent);
  background: var(--eu-accent-light);
}

.eu-course-thumb {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.eu-course-info { flex: 1 1; min-width: 0; }

.eu-course-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--eu-text-primary);
  margin: 0 0 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.eu-course-meta {
  font-size: 0.7rem;
  color: var(--eu-text-muted);
}

.eu-progress-wrap {
  width: 70px;
  flex-shrink: 0;
}

.eu-progress-bar {
  height: 5px;
  border-radius: 99px;
  background: var(--eu-border);
  overflow: hidden;
  margin-bottom: 3px;
}

.eu-progress-fill {
  height: 100%;
  border-radius: 99px;
  background: linear-gradient(90deg, var(--eu-accent), var(--eu-accent-glow-solid, var(--eu-accent)));
  opacity: 0.92;
  transition: width 0.6s cubic-bezier(0.4,0,0.2,1);
}

.eu-progress-pct {
  font-size: 0.7rem;
  color: var(--eu-text-secondary);
  text-align: right;
}

/* ── Documents List ──────────────────────────────────────────── */
.eu-doc-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.eu-doc-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 10px;
  background: var(--eu-surface-2);
  border: 1px solid var(--eu-border);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.eu-doc-item:hover {
  border-color: var(--eu-accent);
  background: var(--eu-accent-light);
}

.eu-doc-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.eu-doc-icon svg { width: 16px; height: 16px; }

.eu-doc-info { flex: 1 1; min-width: 0; }

.eu-doc-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--eu-text-primary);
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.eu-doc-meta {
  font-size: 0.7rem;
  color: var(--eu-text-muted);
}

.eu-doc-badge {
  font-size: 0.65rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 99px;
  flex-shrink: 0;
}

.eu-doc-badge.pending    { background: #fef3c7; color: #b45309; }
.eu-doc-badge.acknowledged { background: #d1fae5; color: #065f46; }
.eu-doc-badge.overdue    { background: #fee2e2; color: #b91c1c; }

.dark .eu-doc-badge.pending    { background: rgba(245,158,11,0.2);  color: #fbbf24; }
.dark .eu-doc-badge.acknowledged { background: rgba(16,185,129,0.2); color: #34d399; }
.dark .eu-doc-badge.overdue    { background: rgba(239,68,68,0.2);   color: #f87171; }

/* ── Incidents List ──────────────────────────────────────────── */
.eu-incident-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.eu-incident-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 13px;
  border-radius: 10px;
  background: var(--eu-surface-2);
  border-left: 3px solid transparent;
  border-top: 1px solid var(--eu-border);
  border-right: 1px solid var(--eu-border);
  border-bottom: 1px solid var(--eu-border);
  cursor: pointer;
  transition: background 0.15s;
}

.eu-incident-item:hover { background: var(--eu-accent-light); }
.eu-incident-item.critical { border-left-color: #ef4444; }
.eu-incident-item.high     { border-left-color: #f97316; }
.eu-incident-item.medium   { border-left-color: #eab308; }
.eu-incident-item.low      { border-left-color: #22c55e; }

.eu-incident-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 5px;
  flex-shrink: 0;
}

.eu-incident-dot.critical { background: #ef4444; }
.eu-incident-dot.high     { background: #f97316; }
.eu-incident-dot.medium   { background: #eab308; }
.eu-incident-dot.low      { background: #22c55e; }

.eu-incident-info { flex: 1 1; min-width: 0; }

.eu-incident-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--eu-text-primary);
  margin: 0 0 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.eu-incident-meta {
  font-size: 0.7rem;
  color: var(--eu-text-muted);
}

.eu-incident-status {
  font-size: 0.65rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 99px;
  flex-shrink: 0;
}

.eu-incident-status.open        { background: #dbeafe; color: #1d4ed8; }
.eu-incident-status.in_progress { background: #fef3c7; color: #92400e; }
.eu-incident-status.resolved    { background: #d1fae5; color: #065f46; }
.eu-incident-status.closed      { background: #f3f4f6; color: #374151; }

.dark .eu-incident-status.open        { background: rgba(59,130,246,0.2); color: #60a5fa; }
.dark .eu-incident-status.in_progress { background: rgba(245,158,11,0.2); color: #fbbf24; }
.dark .eu-incident-status.resolved    { background: rgba(16,185,129,0.2); color: #34d399; }
.dark .eu-incident-status.closed      { background: rgba(107,114,128,0.2); color: #9ca3af; }

/* ── Security Tips ───────────────────────────────────────────── */
.eu-tip-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.eu-tip-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border-radius: 10px;
  background: var(--eu-surface-2);
  border: 1px solid var(--eu-border);
}

.eu-tip-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}

.eu-tip-icon-wrap svg { width: 15px; height: 15px; }

.eu-tip-text {
  flex: 1 1;
}

.eu-tip-title {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--eu-text-primary);
  margin: 0 0 3px;
}

.eu-tip-desc {
  font-size: 0.72rem;
  color: var(--eu-text-secondary);
  line-height: 1.5;
  margin: 0;
}

/* ── Activity Feed ───────────────────────────────────────────── */
.eu-activity-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.eu-activity-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--eu-border);
}

.eu-activity-item:last-child { border-bottom: none; }

.eu-activity-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 5px;
  flex-shrink: 0;
}

.eu-activity-dot.purple { background: var(--eu-accent); }
.eu-activity-dot.green  { background: var(--eu-success); }
.eu-activity-dot.amber  { background: var(--eu-warning); }
.eu-activity-dot.red    { background: var(--eu-danger); }
.eu-activity-dot.blue   { background: var(--eu-info); }

.eu-activity-content { flex: 1 1; min-width: 0; }

.eu-activity-text {
  font-size: 0.78rem;
  color: var(--eu-text-primary);
  margin: 0 0 2px;
}

.eu-activity-time {
  font-size: 0.68rem;
  color: var(--eu-text-muted);
}

/* ── Status Badge Pill ────────────────────────────────────────── */
.eu-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 99px;
}

.eu-badge.active   { background: #d1fae5; color: #065f46; }
.eu-badge.inactive { background: #fee2e2; color: #b91c1c; }
.eu-badge.pending  { background: #fef3c7; color: #92400e; }

.dark .eu-badge.active   { background: rgba(16,185,129,0.2);  color: #34d399; }
.dark .eu-badge.inactive { background: rgba(239,68,68,0.2);   color: #f87171; }
.dark .eu-badge.pending  { background: rgba(245,158,11,0.2);  color: #fbbf24; }

/* ── Loading skeleton ────────────────────────────────────────── */
.eu-skeleton {
  background: linear-gradient(90deg, var(--eu-border) 25%, var(--eu-surface-2) 50%, var(--eu-border) 75%);
  background-size: 200% 100%;
  animation: eu-shimmer 1.5s infinite;
  border-radius: 6px;
}

@keyframes eu-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Staggered fade-in animations ────────────────────────────── */
@keyframes eu-fade-in {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

.eu-animate-1 { animation: eu-fade-in 0.4s ease both 0.05s; }
.eu-animate-2 { animation: eu-fade-in 0.4s ease both 0.12s; }
.eu-animate-3 { animation: eu-fade-in 0.4s ease both 0.19s; }
.eu-animate-4 { animation: eu-fade-in 0.4s ease both 0.26s; }
.eu-animate-5 { animation: eu-fade-in 0.4s ease both 0.33s; }
.eu-animate-6 { animation: eu-fade-in 0.4s ease both 0.40s; }
.eu-animate-7 { animation: eu-fade-in 0.4s ease both 0.47s; }

/* ── Empty state ─────────────────────────────────────────────── */
.eu-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  color: var(--eu-text-muted);
  text-align: center;
  gap: 8px;
}

.eu-empty svg { width: 36px; height: 36px; opacity: 0.4; }

.eu-empty-text {
  font-size: 0.8rem;
  font-weight: 500;
}

/* ── Responsive tweaks ───────────────────────────────────────── */
@media (max-width: 640px) {
  .eu-portal { padding: 16px; }
  .eu-hero   { padding: 24px 20px; }
  .eu-hero-name { font-size: 1.5rem; }
  .eu-stats-row { grid-template-columns: repeat(2, 1fr); }
  .eu-quick-actions { grid-template-columns: 1fr 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/components/EndUser/EndUserPortal.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE,kEAAkE;AAClE;uDACuD;AACvD;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,qDAAqD;EACrD,uCAAuC;EACvC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,oDAAoD;EACpD,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;EACjB,wBAAwB;EACxB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,mFAAmF;EACnF,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;kFAEgF;EAChF,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;wEACsE;EACtE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA,gBAAgB,SAAO,EAAE;;AAEzB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB,kCAAkC,EAAE,uBAAuB,EAAE;AACrF,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D,8BAA8B,kCAAkC,EAAE,uBAAuB,EAAE;AAC3F,8BAA8B,+BAA+B,IAAI,cAAc,EAAE;AACjF,8BAA8B,gCAAgC,GAAG,cAAc,EAAE;AACjF,8BAA8B,gCAAgC,GAAG,cAAc,EAAE;AACjF,8BAA8B,gCAAgC,GAAG,cAAc,EAAE;;AAEjF,gBAAgB,YAAY,EAAE;;AAE9B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW,0BAA0B,EAAE;AACzC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa,qCAAqC,EAAE;AACtD;AACA;EACE,aAAa,0BAA0B,EAAE;AAC3C;;AAEA,mEAAmE;AACnE;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4BAA4B,WAAW,EAAE,YAAY,EAAE;;AAEvD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB,SAAO,EAAE,YAAY,EAAE;;AAEzC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mGAAmG;EACnG,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,mBAAmB,WAAW,EAAE,YAAY,EAAE;;AAE9C,eAAe,SAAO,EAAE,YAAY,EAAE;;AAEtC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE,iCAAiC,gCAAgC,GAAG,cAAc,EAAE;AACpF,mCAAmC,gCAAgC,EAAE,cAAc,EAAE;AACrF,iCAAiC,+BAA+B,IAAI,cAAc,EAAE;;AAEpF,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;EAClC,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;EACzC,eAAe;EACf,4BAA4B;AAC9B;;AAEA,0BAA0B,kCAAkC,EAAE;AAC9D,6BAA6B,0BAA0B,EAAE;AACzD,6BAA6B,0BAA0B,EAAE;AACzD,6BAA6B,0BAA0B,EAAE;AACzD,6BAA6B,0BAA0B,EAAE;;AAEzD;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B,mBAAmB,EAAE;AACjD,4BAA4B,mBAAmB,EAAE;AACjD,4BAA4B,mBAAmB,EAAE;AACjD,4BAA4B,mBAAmB,EAAE;;AAEjD,oBAAoB,SAAO,EAAE,YAAY,EAAE;;AAE3C;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;;AAEvE,wCAAwC,gCAAgC,EAAE,cAAc,EAAE;AAC1F,wCAAwC,gCAAgC,EAAE,cAAc,EAAE;AAC1F,wCAAwC,gCAAgC,EAAE,cAAc,EAAE;AAC1F,wCAAwC,iCAAiC,EAAE,cAAc,EAAE;;AAE3F,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB,WAAW,EAAE,YAAY,EAAE;;AAEnD;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;AACX;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;;AAEA,+BAA+B,mBAAmB,EAAE;;AAEpD;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,0BAA0B,4BAA4B,EAAE;AACxD,0BAA0B,6BAA6B,EAAE;AACzD,0BAA0B,6BAA6B,EAAE;AACzD,0BAA0B,4BAA4B,EAAE;AACxD,0BAA0B,0BAA0B,EAAE;;AAEtD,uBAAuB,SAAO,EAAE,YAAY,EAAE;;AAE9C;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,oEAAoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D,2BAA2B,gCAAgC,GAAG,cAAc,EAAE;AAC9E,2BAA2B,+BAA+B,IAAI,cAAc,EAAE;AAC9E,2BAA2B,gCAAgC,GAAG,cAAc,EAAE;;AAE9E,mEAAmE;AACnE;EACE,uGAAuG;EACvG,0BAA0B;EAC1B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,mEAAmE;AACnE;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,gBAAgB,0CAA0C,EAAE;AAC5D,gBAAgB,0CAA0C,EAAE;AAC5D,gBAAgB,0CAA0C,EAAE;AAC5D,gBAAgB,0CAA0C,EAAE;AAC5D,gBAAgB,0CAA0C,EAAE;AAC5D,gBAAgB,0CAA0C,EAAE;AAC5D,gBAAgB,0CAA0C,EAAE;;AAE5D,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,QAAQ;AACV;;AAEA,gBAAgB,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE;;AAEzD;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,aAAa,aAAa,EAAE;EAC5B,aAAa,kBAAkB,EAAE;EACjC,gBAAgB,iBAAiB,EAAE;EACnC,gBAAgB,qCAAqC,EAAE;EACvD,oBAAoB,8BAA8B,EAAE;AACtD","sourcesContent":["/* ============================================================\n   EndUser Portal — Employee Security Hub\n   Namespace: eu- (all classes prefixed to avoid conflicts)\n   Supports: light / dark / semi-dark via .dark and .semi-dark\n   ============================================================ */\n\n/* ── Custom properties ──────────────────────────────────────── */\n/* Accent tokens are injected directly via inline style by EndUserPortal.js\n   These :root values are last-resort fallbacks only. */\n:root {\n  --eu-bg:            #f5f4ff;\n  --eu-surface:       #ffffff;\n  --eu-surface-2:     #f8f7ff;\n  --eu-border:        #e5e2f0;\n  --eu-text-primary:  #1e1b4b;\n  --eu-text-secondary:#6b7280;\n  --eu-text-muted:    #9ca3af;\n  --eu-accent:        var(--app-primary-color, #1E3A5F);\n  --eu-accent-light:  rgba(30,58,95,0.12);\n  --eu-accent-glow:   rgba(30,58,95,0.20);\n  --eu-hero-from:     #060e1b;\n  --eu-hero-to:       #0e2340;\n  --eu-card-shadow:   0 2px 16px var(--eu-accent-glow);\n  --eu-success:       #10b981;\n  --eu-warning:       #f59e0b;\n  --eu-danger:        #ef4444;\n  --eu-info:          #3b82f6;\n}\n\n.dark {\n  --eu-bg:            #0b0e1a;\n  --eu-surface:       #111827;\n  --eu-surface-2:     #1a2035;\n  --eu-border:        #1f2d45;\n  --eu-text-primary:  #e2e8f0;\n  --eu-text-secondary:#94a3b8;\n  --eu-text-muted:    #546078;\n  --eu-card-shadow:   0 4px 24px rgba(0,0,0,0.5);\n}\n\n.semi-dark {\n  --eu-bg:            #f5f4ff;\n  --eu-surface:       #ffffff;\n  --eu-surface-2:     #f8f7ff;\n  --eu-border:        #e5e2f0;\n  --eu-text-primary:  #1e1b4b;\n  --eu-text-secondary:#6b7280;\n  --eu-text-muted:    #9ca3af;\n  --eu-card-shadow:   0 2px 16px var(--eu-accent-glow);\n}\n\n/* ── Layout wrapper ──────────────────────────────────────────── */\n.eu-portal {\n  min-height: 100vh;\n  background: var(--eu-bg);\n  font-family: 'Inter', system-ui, sans-serif;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n/* ── Hero / Welcome Banner ───────────────────────────────────── */\n.eu-hero {\n  position: relative;\n  background: linear-gradient(135deg, var(--eu-hero-from) 0%, var(--eu-hero-to) 100%);\n  border-radius: 20px;\n  padding: 36px 40px;\n  margin-bottom: 28px;\n  overflow: hidden;\n  color: #fff;\n}\n\n.eu-hero::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image:\n    radial-gradient(circle at 80% 20%, rgba(255,255,255,0.07) 0%, transparent 50%),\n    radial-gradient(circle at 20% 80%, rgba(255,255,255,0.05) 0%, transparent 40%);\n  pointer-events: none;\n}\n\n/* Subtle dot grid */\n.eu-hero::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image:\n    radial-gradient(circle, rgba(255,255,255,0.08) 1px, transparent 1px);\n  background-size: 28px 28px;\n  pointer-events: none;\n}\n\n.eu-hero-content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.eu-hero-left { flex: 1; }\n\n.eu-greeting {\n  font-size: 0.8rem;\n  font-weight: 500;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.7);\n  margin: 0 0 6px;\n}\n\n.eu-hero-name {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 10px;\n  line-height: 1.15;\n  color: #fff;\n}\n\n.eu-hero-sub {\n  font-size: 0.875rem;\n  color: rgba(255,255,255,0.75);\n  margin: 0;\n}\n\n.eu-hero-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n/* Awareness Score Ring */\n.eu-score-ring {\n  position: relative;\n  width: 96px;\n  height: 96px;\n  flex-shrink: 0;\n}\n\n.eu-score-ring svg {\n  transform: rotate(-90deg);\n}\n\n.eu-score-center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.eu-score-value {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1;\n}\n\n.eu-score-label {\n  font-size: 0.55rem;\n  color: rgba(255,255,255,0.7);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-top: 2px;\n}\n\n.eu-score-info {\n  text-align: left;\n}\n\n.eu-score-info-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #fff;\n  margin: 0 0 6px;\n}\n\n.eu-score-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.eu-score-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.75rem;\n  color: rgba(255,255,255,0.8);\n}\n\n.eu-score-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* ── Quick Stats Row ─────────────────────────────────────────── */\n.eu-stats-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 16px;\n  margin-bottom: 28px;\n}\n\n.eu-stat-card {\n  background: var(--eu-surface);\n  border: 1px solid var(--eu-border);\n  border-radius: 14px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: var(--eu-card-shadow);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  cursor: pointer;\n}\n\n.eu-stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 28px var(--eu-accent-glow);\n}\n\n.eu-stat-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.eu-stat-icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.eu-stat-icon.purple  { background: var(--eu-accent-light); color: var(--eu-accent); }\n.eu-stat-icon.red     { background: #fee2e2; color: #ef4444; }\n.eu-stat-icon.blue    { background: #dbeafe; color: #3b82f6; }\n.eu-stat-icon.green   { background: #d1fae5; color: #10b981; }\n.eu-stat-icon.amber   { background: #fef3c7; color: #f59e0b; }\n\n.dark .eu-stat-icon.purple  { background: var(--eu-accent-light); color: var(--eu-accent); }\n.dark .eu-stat-icon.red     { background: rgba(239,68,68,0.2);   color: #f87171; }\n.dark .eu-stat-icon.blue    { background: rgba(59,130,246,0.2);  color: #60a5fa; }\n.dark .eu-stat-icon.green   { background: rgba(16,185,129,0.2);  color: #34d399; }\n.dark .eu-stat-icon.amber   { background: rgba(245,158,11,0.2);  color: #fbbf24; }\n\n.eu-stat-text { min-width: 0; }\n\n.eu-stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--eu-text-primary);\n  line-height: 1;\n  margin-bottom: 2px;\n}\n\n.eu-stat-label {\n  font-size: 0.75rem;\n  color: var(--eu-text-secondary);\n  font-weight: 500;\n}\n\n/* ── Main content grid ────────────────────────────────────────── */\n.eu-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 900px) {\n  .eu-grid { grid-template-columns: 1fr; }\n}\n\n.eu-grid-3 {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 1100px) {\n  .eu-grid-3 { grid-template-columns: repeat(2, 1fr); }\n}\n@media (max-width: 700px) {\n  .eu-grid-3 { grid-template-columns: 1fr; }\n}\n\n/* ── Generic card ────────────────────────────────────────────── */\n.eu-card {\n  background: var(--eu-surface);\n  border: 1px solid var(--eu-border);\n  border-radius: 16px;\n  padding: 22px;\n  box-shadow: var(--eu-card-shadow);\n}\n\n.eu-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n\n.eu-card-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--eu-text-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.eu-card-title-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: var(--eu-accent-light);\n  color: var(--eu-accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 0.2s, color 0.2s;\n}\n\n.eu-card-title-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.eu-card-action {\n  font-size: 0.75rem;\n  color: var(--eu-accent);\n  font-weight: 600;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 4px 8px;\n  border-radius: 6px;\n  text-decoration: none;\n  transition: background 0.15s, color 0.2s;\n}\n\n.eu-card-action:hover {\n  background: var(--eu-accent-light);\n}\n\n/* ── Quick Actions ───────────────────────────────────────────── */\n.eu-quick-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.eu-quick-action {\n  background: var(--eu-surface-2);\n  border: 1px solid var(--eu-border);\n  border-radius: 12px;\n  padding: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  text-decoration: none;\n}\n\n.eu-quick-action:hover {\n  border-color: var(--eu-accent);\n  background: var(--eu-accent-light);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px var(--eu-accent-glow);\n}\n\n.eu-quick-action-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.eu-quick-action-icon svg { width: 18px; height: 18px; }\n\n.eu-quick-action-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--eu-text-primary);\n  line-height: 1.3;\n}\n\n.eu-quick-action-desc {\n  font-size: 0.7rem;\n  color: var(--eu-text-muted);\n}\n\n/* ── Learning Progress ───────────────────────────────────────── */\n.eu-course-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.eu-course-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 10px;\n  background: var(--eu-surface-2);\n  border: 1px solid var(--eu-border);\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.eu-course-item:hover {\n  border-color: var(--eu-accent);\n  background: var(--eu-accent-light);\n}\n\n.eu-course-thumb {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n\n.eu-course-info { flex: 1; min-width: 0; }\n\n.eu-course-name {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--eu-text-primary);\n  margin: 0 0 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.eu-course-meta {\n  font-size: 0.7rem;\n  color: var(--eu-text-muted);\n}\n\n.eu-progress-wrap {\n  width: 70px;\n  flex-shrink: 0;\n}\n\n.eu-progress-bar {\n  height: 5px;\n  border-radius: 99px;\n  background: var(--eu-border);\n  overflow: hidden;\n  margin-bottom: 3px;\n}\n\n.eu-progress-fill {\n  height: 100%;\n  border-radius: 99px;\n  background: linear-gradient(90deg, var(--eu-accent), var(--eu-accent-glow-solid, var(--eu-accent)));\n  opacity: 0.92;\n  transition: width 0.6s cubic-bezier(0.4,0,0.2,1);\n}\n\n.eu-progress-pct {\n  font-size: 0.7rem;\n  color: var(--eu-text-secondary);\n  text-align: right;\n}\n\n/* ── Documents List ──────────────────────────────────────────── */\n.eu-doc-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.eu-doc-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 10px;\n  background: var(--eu-surface-2);\n  border: 1px solid var(--eu-border);\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.eu-doc-item:hover {\n  border-color: var(--eu-accent);\n  background: var(--eu-accent-light);\n}\n\n.eu-doc-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.eu-doc-icon svg { width: 16px; height: 16px; }\n\n.eu-doc-info { flex: 1; min-width: 0; }\n\n.eu-doc-name {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--eu-text-primary);\n  margin: 0 0 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.eu-doc-meta {\n  font-size: 0.7rem;\n  color: var(--eu-text-muted);\n}\n\n.eu-doc-badge {\n  font-size: 0.65rem;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 99px;\n  flex-shrink: 0;\n}\n\n.eu-doc-badge.pending    { background: #fef3c7; color: #b45309; }\n.eu-doc-badge.acknowledged { background: #d1fae5; color: #065f46; }\n.eu-doc-badge.overdue    { background: #fee2e2; color: #b91c1c; }\n\n.dark .eu-doc-badge.pending    { background: rgba(245,158,11,0.2);  color: #fbbf24; }\n.dark .eu-doc-badge.acknowledged { background: rgba(16,185,129,0.2); color: #34d399; }\n.dark .eu-doc-badge.overdue    { background: rgba(239,68,68,0.2);   color: #f87171; }\n\n/* ── Incidents List ──────────────────────────────────────────── */\n.eu-incident-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.eu-incident-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 13px;\n  border-radius: 10px;\n  background: var(--eu-surface-2);\n  border-left: 3px solid transparent;\n  border-top: 1px solid var(--eu-border);\n  border-right: 1px solid var(--eu-border);\n  border-bottom: 1px solid var(--eu-border);\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.eu-incident-item:hover { background: var(--eu-accent-light); }\n.eu-incident-item.critical { border-left-color: #ef4444; }\n.eu-incident-item.high     { border-left-color: #f97316; }\n.eu-incident-item.medium   { border-left-color: #eab308; }\n.eu-incident-item.low      { border-left-color: #22c55e; }\n\n.eu-incident-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-top: 5px;\n  flex-shrink: 0;\n}\n\n.eu-incident-dot.critical { background: #ef4444; }\n.eu-incident-dot.high     { background: #f97316; }\n.eu-incident-dot.medium   { background: #eab308; }\n.eu-incident-dot.low      { background: #22c55e; }\n\n.eu-incident-info { flex: 1; min-width: 0; }\n\n.eu-incident-title {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--eu-text-primary);\n  margin: 0 0 3px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.eu-incident-meta {\n  font-size: 0.7rem;\n  color: var(--eu-text-muted);\n}\n\n.eu-incident-status {\n  font-size: 0.65rem;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 99px;\n  flex-shrink: 0;\n}\n\n.eu-incident-status.open        { background: #dbeafe; color: #1d4ed8; }\n.eu-incident-status.in_progress { background: #fef3c7; color: #92400e; }\n.eu-incident-status.resolved    { background: #d1fae5; color: #065f46; }\n.eu-incident-status.closed      { background: #f3f4f6; color: #374151; }\n\n.dark .eu-incident-status.open        { background: rgba(59,130,246,0.2); color: #60a5fa; }\n.dark .eu-incident-status.in_progress { background: rgba(245,158,11,0.2); color: #fbbf24; }\n.dark .eu-incident-status.resolved    { background: rgba(16,185,129,0.2); color: #34d399; }\n.dark .eu-incident-status.closed      { background: rgba(107,114,128,0.2); color: #9ca3af; }\n\n/* ── Security Tips ───────────────────────────────────────────── */\n.eu-tip-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.eu-tip-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 10px;\n  background: var(--eu-surface-2);\n  border: 1px solid var(--eu-border);\n}\n\n.eu-tip-icon-wrap {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.eu-tip-icon-wrap svg { width: 15px; height: 15px; }\n\n.eu-tip-text {\n  flex: 1;\n}\n\n.eu-tip-title {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--eu-text-primary);\n  margin: 0 0 3px;\n}\n\n.eu-tip-desc {\n  font-size: 0.72rem;\n  color: var(--eu-text-secondary);\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* ── Activity Feed ───────────────────────────────────────────── */\n.eu-activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.eu-activity-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--eu-border);\n}\n\n.eu-activity-item:last-child { border-bottom: none; }\n\n.eu-activity-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-top: 5px;\n  flex-shrink: 0;\n}\n\n.eu-activity-dot.purple { background: var(--eu-accent); }\n.eu-activity-dot.green  { background: var(--eu-success); }\n.eu-activity-dot.amber  { background: var(--eu-warning); }\n.eu-activity-dot.red    { background: var(--eu-danger); }\n.eu-activity-dot.blue   { background: var(--eu-info); }\n\n.eu-activity-content { flex: 1; min-width: 0; }\n\n.eu-activity-text {\n  font-size: 0.78rem;\n  color: var(--eu-text-primary);\n  margin: 0 0 2px;\n}\n\n.eu-activity-time {\n  font-size: 0.68rem;\n  color: var(--eu-text-muted);\n}\n\n/* ── Status Badge Pill ────────────────────────────────────────── */\n.eu-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: 99px;\n}\n\n.eu-badge.active   { background: #d1fae5; color: #065f46; }\n.eu-badge.inactive { background: #fee2e2; color: #b91c1c; }\n.eu-badge.pending  { background: #fef3c7; color: #92400e; }\n\n.dark .eu-badge.active   { background: rgba(16,185,129,0.2);  color: #34d399; }\n.dark .eu-badge.inactive { background: rgba(239,68,68,0.2);   color: #f87171; }\n.dark .eu-badge.pending  { background: rgba(245,158,11,0.2);  color: #fbbf24; }\n\n/* ── Loading skeleton ────────────────────────────────────────── */\n.eu-skeleton {\n  background: linear-gradient(90deg, var(--eu-border) 25%, var(--eu-surface-2) 50%, var(--eu-border) 75%);\n  background-size: 200% 100%;\n  animation: eu-shimmer 1.5s infinite;\n  border-radius: 6px;\n}\n\n@keyframes eu-shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Staggered fade-in animations ────────────────────────────── */\n@keyframes eu-fade-in {\n  from { opacity: 0; transform: translateY(16px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.eu-animate-1 { animation: eu-fade-in 0.4s ease both 0.05s; }\n.eu-animate-2 { animation: eu-fade-in 0.4s ease both 0.12s; }\n.eu-animate-3 { animation: eu-fade-in 0.4s ease both 0.19s; }\n.eu-animate-4 { animation: eu-fade-in 0.4s ease both 0.26s; }\n.eu-animate-5 { animation: eu-fade-in 0.4s ease both 0.33s; }\n.eu-animate-6 { animation: eu-fade-in 0.4s ease both 0.40s; }\n.eu-animate-7 { animation: eu-fade-in 0.4s ease both 0.47s; }\n\n/* ── Empty state ─────────────────────────────────────────────── */\n.eu-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 30px 20px;\n  color: var(--eu-text-muted);\n  text-align: center;\n  gap: 8px;\n}\n\n.eu-empty svg { width: 36px; height: 36px; opacity: 0.4; }\n\n.eu-empty-text {\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n/* ── Responsive tweaks ───────────────────────────────────────── */\n@media (max-width: 640px) {\n  .eu-portal { padding: 16px; }\n  .eu-hero   { padding: 24px 20px; }\n  .eu-hero-name { font-size: 1.5rem; }\n  .eu-stats-row { grid-template-columns: repeat(2, 1fr); }\n  .eu-quick-actions { grid-template-columns: 1fr 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
